import { ActionType, SplashChangedAction } from './actiontypes';
import { SplashState } from '@/state/SplashState';
import { Integration } from '@/middleware/integration';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { EksportChangelog } from '@/server/responses';
import { Dispatch } from '@/state/store';

export type changeSplashT = (splash: SplashState) => (dispatch: Dispatch) => void;
export const changeSplash: changeSplashT = (splash: SplashState) => dispatch => {
    const changeSplashAction: SplashChangedAction = {
        type: ActionType.SHOW_SPLASH,
        state: splash,
    };
    dispatch(changeSplashAction);
};
export const fetchEksportChangelog = createAsyncThunk<
    EksportChangelog,
    never,
    { extra: Integration }
>('splash/fetchEksportChangelog', async (_, { extra }) => {
    return extra.server.getExportChangelog();
});
